<script>
    import {createEventDispatcher} from 'svelte';
    import {getObjects, getObj} from '../lib/data.js';
    import Form from '../Forms/Form.svelte';
    import SortableTable from "../Utilities/SortableTable.svelte";
    import Liquid from 'liquidjs';
    import uuid4 from '../lib/uuid_v4.js';


    const dispatch = createEventDispatcher();
    const engine = new Liquid.Liquid();

    export let assessment_id;
    export let section;

    let name_filter;
    let severity_filter;
    let type_filter = "burp";

    let burp_findings = [];
    let nessus_findings = [];
    let transforms = [];
    let tables = [];

    let findings_table;

    let selected_findings = [];
    let selected_transform;

    let filtered_hosts = [];

    function custom_sort(a,b) {
        return b.finding_severity - a.finding_severity
    }

    let currentFinding;

    function loadData() {
        let filters = {
            assessment_id: assessment_id,
        }

        // get burp findings
        filters.finding_type = "burp"
        getObjects("assessmentHosts", filters).then((findings) => burp_findings = findings);

        // get nessus findings
        filters.finding_type = "nessus"
        getObjects("assessmentHosts", filters).then((findings) => nessus_findings = findings);

        // get transforms
        getObjects("transform").then((t) => {
            transforms = t;
            selected_transform = transforms[0];
        });

        getObjects("table").then((t) => {
            tables = t;
            if (!section.table) {
                section.table = tables[0].id;
            }
        })
    }

    function addFinding(finding) {
        finding.transform = selected_transform;
        selected_findings = [...selected_findings, finding]
    }



    function removeFinding(finding) {
        selected_findings = selected_findings.filter((f) => f != finding)
    }

    function filterFindings(name_filter, severity_filter, type_filter, burp_finding, nessus_findings) {
        let results;

        if (type_filter == "burp") {
            results = JSON.parse(JSON.stringify(burp_findings));
        } else if (type_filter == "nessus") {
            results = JSON.parse(JSON.stringify(nessus_findings));
        }

        for (let host of results) {

            if (severity_filter != null) {
                for (let host of results) {
                    host.findings = host.findings.filter((finding) => finding.finding_severity == severity_filter)
                }
            }

            if (name_filter) {
                host.findings = host.findings.filter((finding) => finding.finding_name.toUpperCase().includes(name_filter.toUpperCase()))
            }
            host.findings = host.findings.sort(custom_sort);
        }

        return results;
    }

    function extractField(extract, finding) {
        if (!finding) return [];

        let field_value = finding[extract.field];
        if (!field_value) return [];

        let re;

        if (!extract.regex) return [];

        try{
            re = new RegExp(extract.regex, 'g');
        } catch (err) {
            return [];
        }

        return [...field_value.matchAll(re)];
    }

    async function editFinding(finding) {
        let form = [];
        let form_data = {
            id: finding.id,
            finding_name: finding.finding_name,
            finding_severity: finding.finding_severity
        };

        form.push({
            name: 'id',
            type: 'hidden'
        })

        form.push({
            "name": "finding_name",
            label: "Finding Name",
            type: 'text'
        });

        form.push({
            name: "finding_severity",
            label: "Finding Severity",
            type: 'select',
            choices: {
                static: [
                    {label: "High", value:3},
                    {label: "Medium", value:2},
                    {label: "Low", value:1},
                ]
            }
        })

        for (let field in finding.details) {
            let form_field = {
                "name": field,
                "label": field,
                "type": "textarea",
                "placeholder": field
            }
            form.push(form_field)
            form_data[field] = finding.details[field];
        }

        currentFinding = {
            fields: form,
            data: form_data
        }
        console.log(currentFinding);
    }

    function saveFinding(finding) {
        console.log(finding);
        let toplevel_fields = ['finding_name', 'finding_severity', 'id'];

        let newField = {
            id: '',
            finding_name: '',
            finding_severity: 0,
            details: {}
        };

        // reconstruct finding
        for (let field in finding) {
            if (toplevel_fields.indexOf(field) !== -1) {
                newField[field] = finding[field]
            } else {
                newField.details[field] = finding[field]
            }
        }

        section.findings = section.findings.map((f) => f.id == newField.id ? newField : f);

        console.log(section.findings);
        currentFinding = undefined;
    }

    async function addFindingsToSection() {
        let promises = [];

        // Kick off all promises
        for (let finding_info of selected_findings) {
            promises.push([finding_info, getObj("assessmentFinding", finding_info.id)]);
        }

        for (let promise of promises) {
            // process promises synchronously

            let finding = await(promise[1]);

            let transformed_finding = {
                id: uuid4(),
                finding_name: finding.finding_name,
                finding_severity: finding.finding_severity,
                details: {}
            };

            for (let extract of promise[0].transform.extractions) {
                transformed_finding.details[extract.name] = extractField(extract, finding);
            }

            for (let transform of promise[0].transform.transforms) {
                transformed_finding.details[transform.name] = engine.parseAndRenderSync(transform.template, finding.finding_details)
            }

            // remove extract fields
            for (let extract of promise[0].transform.extractions) {
                delete transformed_finding.details[extract.name]
            }

            section.findings = [...section.findings, transformed_finding]
        }

        selected_findings = [];
    }

    function removeFindingFromSection(finding) {
        section.findings = section.findings.filter((f) => f.id != finding.id)
    }

    function closeFinding() {
        dispatch("close", {
            table: section.table,
            findings: section.findings
        });
    }

    $: filtered_hosts = filterFindings(name_filter, severity_filter, type_filter, burp_findings, nessus_findings);
    loadData()
</script>

<style>
    .select {
        margin-bottom: 20px;
    }

    .link {
        cursor: auto;
    }

    .fa-plus {
        cursor: pointer;
    }

    .sev-icon {
        color: white;
        float:left;
        width: 1.5em;
        height: 1.5em;
        border-radius: 50%;
        margin-right: 10px;
        text-align:center;
    }

    .sev-icon.sev-3 {background-color: red;}
    .sev-icon.sev-2 {background-color: Orange;}
    .sev-icon.sev-1 {background-color: green;}
    .sev-icon.sev-0 {background-color: gray}
</style>

<h1 class="title is-1">
    {section.name}
    <button class="button is-success is-pulled-right" on:click={closeFinding}>Done</button>
</h1>


<div class="columns">
    <div class="column is-3">
        <div class="menu">
            <ul class="menu-list">
                <li>
                    <p class="menu-label">
                        Severity:
                    </p>
                    <div class="buttons has-addons is-centered">
                        <div class="button" class:is-info={severity_filter == null} on:click={() => severity_filter = null }>All</div>
                        <div class="button" class:is-light={severity_filter == 0} on:click={() => severity_filter = 0 }>Informational</div>
                        <div class="button" class:is-success={severity_filter == 1} on:click={() => severity_filter = 1 }>Low</div>
                        <div class="button" class:is-warning={severity_filter == 2} on:click={() => severity_filter = 2 }>Medium</div>
                        <div class="button" class:is-danger={severity_filter == 3} on:click={() => severity_filter = 3 }>High</div>
                    </div>
                    <p class="menu-label">
                        Finding Type:
                    </p>
                    <div class="buttons has-addons is-centered">
                        <div class="button" class:is-light={type_filter == "burp"} on:click={() => type_filter = "burp"}>Burp</div>
                        <div class="button" class:is-light={type_filter == "nessus"} on:click={() => type_filter = "nessus"}>Nessus</div>
                    </div>
                    <div class="field">
                        <div class="control has-icons-left">
                            <input type="text" class="input is-rounded" placeholder="Search" bind:value={name_filter}>
                            <span class="icon is-small is-left">
                                <i class="fas fa-search"></i>
                            </span>
                        </div>
                    </div>
                    <p class="menu-label">
                        Transform:
                    </p>
                    <div class="select">
                        <select bind:value={selected_transform}>
                            {#each transforms as transform}
                                <option value={transform}>{transform.name}</option>
                            {/each}
                        </select>
                    </div>
                </li>
            </ul>
            <p class="menu-label">
                Findings
            </p>
            <ul class="menu-list">
                {#each filtered_hosts as host}
                    <span class="link">{host.ip}</span>
                        <ul>
                            {#each host.findings as finding}
                            <li>
                                <span class="link" data-id={finding.id}>
                                    <div class="columns">
                                        <div class="column">
                                            <div class="sev-icon sev-{finding.finding_severity}">!</div>
                                            {finding.finding_name}
                                        </div>
                                        <div class="column is-narrow">
                                            <i class="icon fas fa-plus" on:click={() => addFinding(finding)}></i>
                                        </div>
                                    </div>
                                </span>
                            </li>
                            {/each}
                        </ul>
                {/each}
            </ul>
        </div>
    </div>
    <div class="column">
        <h2 class="title is-4">Findings Template</h2>
        <div class="select is-fullwidth">
            <select bind:value={section.table}>
                {#each tables as table}
                    <option value="{table.id}">{table.name}</option>
                {/each}
            </select>
        </div>

        <h2 class="title is-4">Selected Finding</h2>
        <table class="table is-striped is-fullwidth">
            <thead>
                <tr>
                    <th>Finding</th>
                    <th style="width: 350px">Transform</th>
                    <th style="width: 125px">Actions</th>
                </tr>
            </thead>
            <tbody>
                {#each selected_findings as finding}
                    <tr>
                        <td>{finding.finding_name}</td>
                        <td>
                            <div class="select">
                                <select bind:value={finding.transform}>
                                    {#each transforms as transform}
                                        <option value={transform}>{transform.name}</option>
                                    {/each}
                                </select>
                            </div>
                        </td>
                        <td>
                            <button class="button is-danger" on:click={() => removeFinding(finding)}>Remove</button>
                        </td>
                    </tr>
                {/each}
            </tbody>
            <tfoot>
                <tr>
                    <td colspan=3>
                        <button class="button is-pulled-right is-info" on:click={addFindingsToSection}>Add to Section</button>
                    </td>
                </tr>
            </tfoot>
        </table>

        <h2 class="title is-4">Section Findings</h2>
         <table class="table is-striped is-fullwidth">
            <thead>
                <tr>
                    <th colspan="2">Finding</th>
                    <th>Severity</th>
                    <th style="width: 250px">Actions</th>
                </tr>
            </thead>
            <tbody>
                <SortableTable bind:list={section.findings} let:item={finding} on:sort={(evt) =>section.findings = evt.detail}>
                    <td class="is-narrow"><i class="fas fa-grip-lines" style="cursor: grab"></i></td>
                    <td>{finding.finding_name}</td>
                    <td>{finding.finding_severity}</td>
                    <td>
                        <button class="button is-link" on:click={() => editFinding(finding)}>Edit</button>
                        <button class="button is-danger" on:click={() => removeFindingFromSection(finding)}>Remove</button>
                    </td>
                </SortableTable>
            </tbody>
        </table>
    </div>
</div>

{#if currentFinding}
        <div class="modal is-active">
            <div class="modal-background" on:click={() => currentFinding = undefined}></div>
            <div class="modal-content">
                <div class="box">
                    <Form {...currentFinding} on:submit={(evt) => saveFinding(evt.detail)}></Form>
                </div>
            </div>
            <button class="modal-close is-large" aria-label="close"></button>
    </div>
{/if}